<template>
  <InfiniteScroll
    @fetch="fetch"
  >
    <template #content>
      <div class="flex flex-wrap -mx-4">
        <div
          v-for="ctrip in trips"
          :key="`trip-${ctrip.id}`"
          class="w-12/12 px-4"
        >
          <CategoryTripCard
            :trip="ctrip"
            class="mb-3"
          />
        </div>
      </div>
    </template>
    <template #loading>
      <Loading v-show="showLoading" />
    </template>
  </InfiniteScroll>
</template>

<script>
export default defineNuxtComponent({
  props: {
    list: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['fetch'],

  data () {
    return {
      page: 1,
      perChunk: 6,
    }
  },

  computed: {
    n () {
      return this.page * this.perChunk
    },

    uniqueList () {
      return this.list || []
    },

    listIsFullyLoaded () {
      return this.n > this.uniqueList.length
    },

    trips () {
      return this.uniqueList.slice(0, this.n)
    },

    showLoading () {
      return this.loading || !this.listIsFullyLoaded
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.fetch()
    })
  },

  methods: {
    fetch () {
      if (this.loading) {
        this.$emit('fetch')
      }
      if (!this.listIsFullyLoaded) {
        this.page += 1
      }
    },
  },
})
</script>
